import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { FormService } from '../../shared/form.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PaymentService } from '../../services/payment.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { filter, catchError, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { SharedService } from '../../shared/shared.service';
import { of } from 'rxjs';
import { TrackService } from 'src/app/services/track.service';
import { ProposalService } from 'src/app/shared/proposal.service';
import { LoadedFromCPService } from 'src/app/shared/loaded-from-customer-portal.service';
import { HttpClient } from '@angular/common/http';


interface IXOptions {
  stepIndex: number;
  progress: number;
  footerContent?: string;
  leftButtonsList?: [];
  rightButtonsList?: [];
  outlet?: any;
  backArrow?: any;
  formDisabled?: boolean;
  newCar: boolean;
}

const XDefaults: IXOptions = {
  stepIndex: 0,
  progress: 0,
  footerContent: '',
  leftButtonsList: [],
  rightButtonsList: [],
  backArrow: null,
  outlet: null,
  formDisabled: false,
  newCar: false
};

@Component({
  selector: 'app-owner-details',
  templateUrl: './owner-details.component.html',
  styleUrls: ['./owner-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class OwnerDetailsComponent implements OnInit, AfterViewInit, AfterContentInit {
  parentForm;
  formGroupName = 'personInsurerData';
  data: any = {};
  isCompany;
  hideAddress;
  ownerDetailsForm;
  phoneCodes =[] ;
  phonePattern;
  formData;

  formStreet;
  formBlock;
  formStreetNumber;
  formApartament;
  formEntrance;
  formFloor;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    public formService: FormService,
    public sharedService: SharedService,
    public http: HttpClient,
    public formBuilder: FormBuilder,
    public proposalService: ProposalService,
    private loadedFromCPService: LoadedFromCPService,
    public trackService: TrackService) {
    this.parentForm = formService.currentForm;
    this.formData = this.formService.currentForm.getRawValue();
    this.formApartament = (this.formData.apartment && this.formData.apartment!=='') ? 'ап. ' + this.formData.apartment : '';
    this.formBlock = (this.formData.block && this.formData.block!=='') ? 'бл. ' + this.formData.block + ' ' : '';
    this.formStreetNumber = (this.formData.streetNumber && this.formData.streetNumber!=='') ? '№' + this.formData.streetNumber + ' ' : '';
    this.formEntrance = (this.formData.entrance && this.formData.entrance!=='') ? 'вх. ' + this.formData.entrance+ ' ' : '';
    this.formFloor = (this.formData.floor && this.formData.floor!=='') ? 'ет. ' + this.formData.floor+ ' ' : '';
    this.formStreet = this.formData.street+ ' ' || '';
    if(!this.parentForm.controls.ownerData.controls.address.value ){
      this.setAddress();
    }
    if (this.formData.isPropertyAddressSameAsCorrespondence == "Y") {
      this.hideAddress = false;
    }
    else
      this.hideAddress = true;

    let data = this.route.data['value'];
    if (data) {
      this.updateControl(data);
    } else {
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          data = this.route.snapshot?.data;
          this.updateControl(data);
        });
    }
  }

  get phoneNumber() {
    return this.parentForm.controls.ownerData.get('phoneNumber');
  }
  get countryCode() {
    return this.parentForm.controls.ownerData.get('countryCode');
  }


  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsUntouched();
      control.setErrors({ 'incorrect': true });

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  updateFormControl(path) {
    this.formService.currentForm.get(path).patchValue(true);
  }

  updateControl(snapshotData) {
    if (snapshotData?.formGroupName) {
      this.formGroupName = snapshotData.formGroupName;
    }
    Object.assign(this.data, snapshotData);
  }

  trackByIndex(index: number) {
    return index;
  };

  ngAfterViewInit() {
  }

  ngAfterContentInit() {
    this.markFormGroupTouched(this.formService.currentForm);
  }

  clearContactDetails(details) {
    ['eik', 'companyName', 'phoneNumber', 'egn', 'firstName', 'middleName', 'lastName', 'firstNameInLatin', 'middleNameInLatin', 'lastNameInLatin', 'addressInLatin', 'email'].map(item => {
      if (details[item]) {
        delete details[item];
      }
    });
    return details
  }

  ngOnInit(): void {
    this.parentForm = this.formService.currentForm;
    const countryCode =  this.parentForm.controls.firstCountryCode

    this.sharedService.getPhoneCodes().subscribe((res) => {
      this.phoneCodes=res.map(function (el:any) { return el.value; });
      if (this.parentForm.controls.samePerson.value == "Y") {
          if(this.loadedFromCPService._isCustomerPortal ==true){
            this.loadedFromCPService.loadDataOwnerFromCP();
          }
          else {
            if(this.parentForm.controls.ownerData.controls.countryCode.value===null){
              this.parentForm.controls.ownerData.controls.countryCode.setValue(countryCode.value);
            }
        }
        if(this.parentForm.controls.ownerData.controls.countryCode.value===null)
          this.parentForm.controls.ownerData.controls.countryCode.setValue(countryCode.value);
      }

      else{
        if(this.loadedFromCPService._isCustomerPortal ==true){
          this.loadedFromCPService.loadDataInsurerFromCP();
        }
        else{
          if(this.parentForm.controls.policyholderData.controls.countryCode.value===null){
          this.parentForm.controls.policyholderData.controls.countryCode.setValue(countryCode.value);
          this.parentForm.controls.ownerData.controls.countryCode.setValue('+' + this.phoneCodes[0]);
          }
        }
        if(this.parentForm.controls.ownerData.controls.countryCode.value===null)
          this.parentForm.controls.ownerData.controls.countryCode.setValue(countryCode.value);
      }
    });

    //this.markFormGroupTouched(this.formService.currentForm);
    const phone = this.parentForm.controls.firstPhoneNumber;
    const name = this.parentForm.controls.firstFirstName;
    if (this.parentForm.controls.samePerson.value == "Y") {
      this.parentForm.controls.ownerData.controls.phoneNumber.setValue(phone.value);
      this.parentForm.controls.policyholderData.controls.phoneNumber.setValue(null);
      this.parentForm.controls.ownerData.controls.firstName.setValue(name.value);
      this.parentForm.controls.policyholderData.controls.firstName.setValue(null);
    }
    if (this.parentForm.controls.samePerson.value == "N") {
      if(!this.parentForm.controls.policyholderData.controls.phoneNumber.value){
        this.parentForm.controls.policyholderData.controls.phoneNumber.setValue(phone.value);
        this.parentForm.controls.policyholderData.controls.firstName.setValue(name.value);
        this.parentForm.controls.policyholderData.controls.countryCode.setValue(countryCode.value);
      }

    }


    this.sharedService.newRegSubj.pipe(catchError(err => of(err)), debounceTime(300), distinctUntilChanged())
      .subscribe((data: any) => {
        if( this.loadedFromCPService._isCustomerPortal ==true && this.parentForm.controls.samePerson.value == "Y"){
          this.isCompany=false;
        }
        else {
          if (data === "INVALID") {
            this.isCompany = null;
          }
          else if (data.length === 10) {
            this.isCompany = false;
          } else if (data.length === 9 || data.length === 13) {
            this.isCompany = true;
            this.parentForm.controls.policyholderData.controls.phoneNumber.setValue(phone.value);
            this.parentForm.controls.ownerData.controls.phoneNumber.setValue(null);
          }
        }

      })
  }

  toText(value): string {
    return value ? value.toUpperCase() : null;
  }

  myFilter(search, itemValue) {
    if (!search) {
      return itemValue.match(new RegExp('^1', 'g')) !== null;
    }
    return itemValue.match(new RegExp('^' + search, 'g')) !== null;
  }

  setAddress(){
    if(this.loadedFromCPService._isCustomerPortal == true && this.parentForm.controls.samePerson.value == "Y" ){
      if(this.parentForm.controls.isPropertyAddressSameAsCorrespondence.value == 'N'){
        return
      }
      else {
        this.formService.currentForm.patchValue({ ownerData: { cityName: this.formData.cityName } })
        this.formService.currentForm.patchValue({ ownerData: { address: `${this.formStreet} ${this.formBlock} ${this.formStreetNumber} ${this.formEntrance} ${this.formFloor} ${this.formApartament}` } })
        this.formService.currentForm.patchValue({ ownerData: { postCode: this.formData.postCode } })
      }
    }
    else {
      if (this.parentForm.controls.ownerData.controls.cityName.value === null) {
        this.formService.currentForm.patchValue({ ownerData: { cityName: this.formData.cityName } })
      }
      if (this.parentForm.controls.ownerData.controls.address.value === null) {
      // if(!this.sharedService.isOfferFromEmail) {
        this.formService.currentForm.patchValue({ ownerData: { address: `${this.formStreet} ${this.formBlock} ${this.formStreetNumber} ${this.formEntrance} ${this.formFloor} ${this.formApartament}` } })
      // }else {
      //   this.formService.currentForm.patchValue({ ownerData: { address: `${this.formData.street}` } })
      // }

      }
      if (this.parentForm.controls.ownerData.controls.postCode.value === null) {
        this.formService.currentForm.patchValue({ ownerData: { postCode: this.formData.postCode } })
      }
    }
  }

  resetOnerData(){
    if(this.parentForm.controls.samePerson.value == "N"){
      this.parentForm.controls.ownerData.reset({
        egn: this.parentForm.controls.ownerData.get('egn').value,
        countryCode: this.parentForm.controls.ownerData.get('countryCode').value
      });
      this.setAddress();
      return;
    }
    return;
  }

  setUserTracking(value, type){
    if(this.parentForm.controls.samePerson.value==="Y"){
      if(type==="firstName"){
        this.proposalService.setInsurerFirstName(value);
      }
      if(type==="lastName"){
        this.proposalService.setInsurerLastName(value);
      }
      if(type==="email"){
        this.proposalService.setInsurerEmail(value);
      }
    }
  }

}
